import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#b4b4bf",
      stroke: "#b4b4bf",
      d: "M7.999 2a6.007 6.007 0 0 1 5.993 5.703l.008.298A6 6 0 1 1 7.999 2ZM10.5 5.5a1 1 0 0 0-.707.293L7 8.586l-.793-.793A1 1 0 0 0 4.5 8.5l.005.099a1 1 0 0 0 .288.608l1.5 1.5a1 1 0 0 0 1.414 0l3.5-3.5A1 1 0 0 0 11.5 6.5l-.005-.099a1 1 0 0 0-.612-.825A1 1 0 0 0 10.5 5.5Z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "check-circle"}) } }